import { Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

const StyledTypography = styled(Typography)`
  max-width: 100px;
  min-width: fit-content;
  margin-left: 4px;
`

export function SenderName({ name }: { name: string }) {
  return name ? (
    <StyledTypography variant="body3" color="primary" noWrap>
      {`${name}:`}
    </StyledTypography>
  ) : null
}
